/**
 * iOS devices eligible for the app-link handoff (see appLinkUrl). Deliberately
 * excludes iPads running desktop-mode Safari (macOS user agent) so the client
 * label/redirect stay consistent with the server's user-agent check in
 * AppLinksController.
 * @returns {boolean}
 */
export const isIOSDevice = () => /iPad|iPhone|iPod/.test(window.navigator.userAgent);
